import { normalizeText } from '@this+that/utils';

import { Person } from '../../services/crm.service';

export type PersonPlacement =
  | { kind: 'insert'; index: number }
  | { kind: 'beyondWindow' };

export const personSortKey = (person: Person): string =>
  normalizeText(person.displayName) || person.displayName;

export const findInsertIndex = (people: Person[], person: Person): number => {
  const key = personSortKey(person);
  // Raw code-unit comparison, never localeCompare: the backend GSI sort key
  // orders by UTF-8 bytes, while ICU collation treats spaces/punctuation as
  // ignorable — a locale-aware compare here would desync a client insert
  // from the ordering of the next page fetched from the server.
  const index = people.findIndex((existing) => personSortKey(existing) > key);
  return index === -1 ? people.length : index;
};

export const insertPersonInOrder = (
  people: Person[],
  person: Person,
): Person[] => {
  const index = findInsertIndex(people, person);
  return [...people.slice(0, index), person, ...people.slice(index)];
};

export const resolvePersonPlacement = (
  people: Person[],
  person: Person,
  hasMore: boolean,
): PersonPlacement => {
  const last = people.at(-1);
  const isWithinLoadedWindow =
    !hasMore || !last || personSortKey(person) <= personSortKey(last);

  return isWithinLoadedWindow
    ? { kind: 'insert', index: findInsertIndex(people, person) }
    : { kind: 'beyondWindow' };
};
